import type { ValidationErrorResponse } from "./ValidationErrorResponse";
import type { ErrorResponse } from "./ErrorResponse";
import type { ResponseConstructorTemplateDto } from "./ResponseConstructorTemplateDto";

export enum GetPositionsTemplateQueryParamsPositionType {
    "SPECIFIC_PRODUCT" = "SPECIFIC_PRODUCT",
    "SELECTION_BY_CHARACTERISTICS" = "SELECTION_BY_CHARACTERISTICS"
}
export type GetPositionsTemplateQueryParams = {
    /**
     * @type string
    */
    positionType: GetPositionsTemplateQueryParamsPositionType;
    /**
     * @type string
    */
    categoryId: string;
    /**
     * @type string | undefined
    */
    type?: string;
};

/**
 * @description Bad Request
*/
export type GetPositionsTemplate400 = ValidationErrorResponse;

/**
 * @description Unauthorized
*/
export type GetPositionsTemplate401 = ErrorResponse;

/**
 * @description Forbidden
*/
export type GetPositionsTemplate403 = ErrorResponse;

/**
 * @description Unprocessable Entity
*/
export type GetPositionsTemplate422 = ValidationErrorResponse;

/**
 * @description Too Many Requests
*/
export type GetPositionsTemplate429 = ErrorResponse;

/**
 * @description Internal Server Error
*/
export type GetPositionsTemplate500 = ErrorResponse;

/**
 * @description OK
*/
export type GetPositionsTemplateQueryResponse = ResponseConstructorTemplateDto;
